(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-summary"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.mpCartTermsGuard) return;
  window.mpCartTermsGuard = true;
  const checkoutSelector = '.cart__checkout-button[name="checkout"]';
  const visible = element => element.getClientRects().length > 0 && getComputedStyle(element).visibility !== 'hidden';
  const describe = (element, id, add) => {
    const tokens = (element.getAttribute('aria-describedby') || '').split(/\s+/).filter(Boolean).filter(token => token !== id);
    if (add) tokens.push(id);
    if (tokens.length) element.setAttribute('aria-describedby', tokens.join(' '));
    else element.removeAttribute('aria-describedby');
  };
  const guard = event => {
    const checkout = event.type === 'submit' ? event.submitter : event.target.closest?.(checkoutSelector);
    if (!checkout?.matches(checkoutSelector) || checkout.disabled || !visible(checkout)) return;
    if (window.rterms?.metafield?.optional === 'on') return;
    const cart = checkout.closest('cart-items-component') || checkout.closest('.cart__ctas')?.parentElement;
    const checkbox = Array.from(cart?.querySelectorAll('.terms-relentless .rterms-checkbox') || []).find(visible);
    if (!checkbox || checkbox.checked) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    const wrapper = checkbox.closest('.terms-relentless');
    let feedback = wrapper.querySelector('[data-mp-terms-error]');
    if (!feedback) {
      feedback = document.createElement('p');
      feedback.id = 'mp-terms-error-' + checkbox.id;
      feedback.dataset.mpTermsError = '';
      feedback.className = 'mp-cart-terms-error';
      feedback.setAttribute('role', 'alert');
      wrapper.append(feedback);
    }
    feedback.hidden = false;
    feedback.textContent = 'Please confirm the delivery terms before continuing.';
    checkbox.setAttribute('aria-invalid', 'true');
    checkbox.setAttribute('aria-required', 'true');
    describe(checkbox, feedback.id, true);
    describe(checkout, feedback.id, true);
    checkbox.focus({ preventScroll: true });
    checkbox.scrollIntoView({ block: 'nearest', behavior: 'auto' });
  };
  // Capture before the app's checkout-button listener; let accepted consent follow its normal path.
  document.addEventListener('click', guard, true);
  document.addEventListener('submit', guard, true);
  document.addEventListener('change', event => {
    const checkbox = event.target;
    if (!checkbox.matches?.('.rterms-checkbox') || !checkbox.checked) return;
    const feedback = checkbox.closest('.terms-relentless')?.querySelector('[data-mp-terms-error]');
    if (!feedback) return;
    feedback.hidden = true;
    feedback.textContent = '';
    checkbox.removeAttribute('aria-invalid');
    describe(checkbox, feedback.id, false);
    document.querySelectorAll(checkoutSelector).forEach(checkout => describe(checkout, feedback.id, false));
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mp-hero-reading-zone"] && !Shopify.designMode) return;
  try {
    const measuredHeroGrids = new WeakSet();
  function sizeHeroReadingZones() {
    const main = document.querySelector('#MainContent');
    if (!main || !['index', 'page.acc'].includes(main.dataset.template)) return;
    main.querySelectorAll('.mp-hero__grid').forEach((grid) => {
      const heading = grid.querySelector('h1');
      if (!heading || measuredHeroGrids.has(grid)) return;
      measuredHeroGrids.add(grid);
      const update = () => {
        if (!grid.isConnected) return;
        const top = Math.max(0, Math.ceil(heading.getBoundingClientRect().bottom - grid.getBoundingClientRect().top + 12));
        grid.style.setProperty('--mp-hero-art-top', `${top}px`);
        grid.style.setProperty('--mp-hero-art-ready', '1');
      };
      update();
      const observer = new ResizeObserver(update);
      observer.observe(heading);
      observer.observe(grid);
      document.fonts.ready.then(update);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sizeHeroReadingZones, { once: true });
  } else {
    sizeHeroReadingZones();
  }
  document.addEventListener('shopify:section:load', sizeHeroReadingZones);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mp-product-nutrition"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mp-product-nutrition')) {
    customElements.define('mp-product-nutrition', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        const select = this.querySelector('[data-mp-nutrition-select]');
        if (!select) return;
        select.addEventListener('change', () => {
          this.querySelectorAll('[data-mp-nutrition-panel]').forEach(panel => {
            panel.hidden = panel.dataset.mpNutritionPanel !== select.value;
          });
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
